import React from 'react';
import { useLocation, useHistory } from 'react-router';
import useApp from '../../store/app/appContext';
import PageWrapper from '../../containers/app/PageWrapper';
import LoginForm from '../../containers/login/LoginForm.js';
import LogoWithCaptionWhite from '../../components/Logos/LogoWithCaptionWhite';
import CopyrightCaption from '../../components/App/CopyrightCaption';
import { LOGO_SIZES } from '../../config';
import SecondaryButton from '../../components/Buttons/SecondaryButton';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function LoginPage() {

  const { appState: { isAuthenticated, updatePassword } } = useApp();
  let query = useQuery();
  
  
  const scanandgo = query.get('scanandgo');
  const becomeAPartner = query.get('becomeAPartner');

  const history = useHistory();

  if (isAuthenticated && !updatePassword) history.push('/dashboard');
  if (isAuthenticated && updatePassword) history.push('/update-password');

  const captionStyle = {
    minWidth: '45%'
  }

  const loginStyleAddon = {
    backgroundColor: 'white',
    minHeight: '820px'
  }

  return (
    <PageWrapper style={loginStyleAddon} className="xl:h-screen xl:bg-d-shape xl:bg-left xl:py-8 xl:px-12 xl:bg-xauto-y100 bg-mobile bg-top py-6 px-8 w-full bg-no-repeat flex flex-col">
      <div className="flex flex-row items-center justify-center xl:justify-between">
        <LogoWithCaptionWhite className={LOGO_SIZES.CAPTION.dynamic}/>
        <div className='w-52 hidden xl:block'>
          <SecondaryButton text='Back to website' onClick={() => history.push('/patient')}/>
        </div>
      </div>
      <div className="flex-grow flex items-center xl:flex-row flex-col py-8 xl:p-0">
          {scanandgo ? 
          <div className='flex flex-col min-h-170 xl:min-h-0' style={captionStyle}>
            <span className='text-white md:text-4xl text-xl'>Book a Scan & Go consultation</span>
            <span className='text-white mt-2'>Log in or sign up in before scheduling an appointment</span>
          </div>
          :
          becomeAPartner ?
          <div className='flex flex-col min-h-170 xl:min-h-0' style={captionStyle}>
            <span className='text-white md:text-4xl text-xl'>Schedule a meeting to become a partner</span>
            <span className='text-white mt-2'>Log in or sign up before scheduling a meeting</span>
          </div>
          :
          <div className='flex flex-col min-h-170 xl:min-h-0' style={captionStyle}>
            <span className='text-white md:text-4xl text-xl'>Welcome to the <strong>Xivix Portal</strong></span>
            <span className='text-white mt-2'>Log in to view and manage all of your ongoing Xivix Treatments</span>
          </div>
          }
        <div className='w-full flex flex-col 2xl:justify-center mt-6 xl:mt-0 xl:ml-24 2xl:ml-0 xl:justify-end justify-center xl:min-w-0'>
          <div className='w-full md:w-auto mx-auto'>
            <LoginForm/>
          </div>
          <div className='mt-12 w-full md:w-96 block xl:hidden mx-auto pt-4'>
            <SecondaryButton text='Back to website' onClick={() => history.push('/patient')}/>
          </div>
        </div>
      </div>
      <div className='flex justify-center xl:justify-end xl:mt-8'>
        <CopyrightCaption/>
      </div>
    </PageWrapper>
  )
}

export default LoginPage
